import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiLookupConstants } from "src/app/shared/constants/api-constants/api-lookup.constants";
import { AddCommentServiceConstants } from "./add-comment-service.constants";
import { ApiCommentsConstants } from "src/app/shared/constants/api-constants/api-comments.constants";
let AddCommentService = class AddCommentService {
    http;
    componentName = AddCommentServiceConstants.COMPONENT_NAME;
    constructor(http) {
        this.http = http;
    }
    getLookupsObservable(params) {
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    saveComment(params) {
        return this.http.post(`${ApiCommentsConstants.URL_COMMENT}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
AddCommentService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], AddCommentService);
export { AddCommentService };
